export const num = (v) => (v === "" || v == null || Number.isNaN(Number(v)) ? null : Number(v));

export const sizeStatusOf = (r) => (!num(r.size_sqft) ? "unknown" : r.size_status === "confirmed" ? "confirmed" : "estimated");

export const roomToForm = (r) => ({
  id: r.id, type: r.type, label: r.label, purpose: r.purpose, size_sqft: r.size_sqft ?? "", staff_fee: r.staff_fee ?? "",
  size_status: r.size_status || "unknown", budget_mode: r.furniture_budget?.mode || (r.type === "other" ? "custom" : "recommended"),
  budget_min: r.furniture_budget?.custom_min ?? "", budget_max: r.furniture_budget?.custom_max ?? "",
});

export const roomPayload = (r) => ({
  id: r.id, type: r.type, label: r.label, purpose: r.purpose,
  size_sqft: num(r.size_sqft) > 0 ? num(r.size_sqft) : null, staff_fee: num(r.staff_fee), size_status: sizeStatusOf(r),
  furniture_budget: { mode: r.budget_mode, custom_min: num(r.budget_min), custom_max: num(r.budget_max) },
});

export const projectPayload = (f) => ({ name: f.name, consultation_type: f.consultation_type, rooms: f.rooms.map(roomPayload) });
